var _style, _path, _path2, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "left-white_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 984.8 957.7"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M856.7 511.4H56.2c-17.9 0-32.5-14.6-32.5-32.5s14.6-32.5 32.5-32.5h800.6c17.9 0 32.5 14.6 32.5 32.5s-14.6 32.5-32.6 32.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M478.9 957.7c-8.3 0-16.6-3.2-23-9.5L9.5 501.8c-12.7-12.7-12.7-33.3 0-46L455.9 9.5c12.7-12.7 33.3-12.7 46 0 12.7 12.7 12.7 33.3 0 46L78.5 478.9l423.4 423.4c12.7 12.7 12.7 33.3 0 46-6.4 6.3-14.7 9.4-23 9.4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 952.3,
    cy: 478.9,
    r: 32.5,
    fill: "#FFF"
  })));
}

export default SvgLeftWhite;